import { useEffect } from "react";
import PrizesExchange from "./hooks/PrizesExchange";
import CanjeaPuntos from "./components/CanjeaPuntos";
import InteractionSelection from "./components/InteractionSelection";

const Exchange = (props) => {
    const vm = PrizesExchange(props);

    useEffect(() => {
        const scroller = document.querySelector('main');
        if (scroller) {
            scroller.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }
    }, [vm.showInteractionSelection]);

    if (vm.showInteractionSelection) {
        return (
            <InteractionSelection
                prize={vm.premioSeleccionado}
                interactions={vm.availableInteractions}
                quantities={vm.interactionQuantities}
                totalScore={vm.selectedInteractionsTotal}
                leftoverScore={vm.leftoverScore}
                userScore={vm.userScore}
                assigningBondaCurrency={vm.assigningBondaCurrency}
                loading={vm.loadingInteractions}
                user={props.user}
                country={vm.country}
                aceptarTerminos={vm.aceptarTerminos}
                onToggleTerms={vm.setAceptarTerminos}
                onViewTerms={vm.handleViewTerms}
                onQuantityChange={vm.setInteractionQuantity}
                onFinish={vm.finishExchange}
                onBack={vm.volverAlCanje}
            />
        );
    }

    return (
        <CanjeaPuntos
            prizes={vm.prizes}
            interactions={vm.availableInteractions}
            quantities={vm.interactionQuantities}
            premioSeleccionado={vm.premioSeleccionado}
            totalScore={vm.selectedInteractionsTotal}
            selectionError={vm.selectionError}
            leftoverScore={vm.leftoverScore}
            userScore={vm.userScore}
            loading={vm.loadingInteractions}
            onQuantityChange={vm.setInteractionQuantity}
            onPremioSelect={vm.handlePremioSelect}
            onContinuar={vm.goToConfirmation}
            onBack={vm.volver}
            redeemedPrizeMessage={vm.redeemedPrizeMessage}
            isPrizeUnavailable={vm.isPrizeUnavailable}
        />
    );
};

export default Exchange;
